"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Main = require("./Main.style");
var _ErrorMessage = _interopRequireDefault(require("../../../ErrorMessage"));
var _IcisLogo = require("../../../IcisLogo/IcisLogo.style");
var _WidthWrapper = _interopRequireDefault(require("../../../WidthWrapper"));
var _CreditsUsage = _interopRequireDefault(require("../CreditsUsage"));
var _PrimaryNav = _interopRequireDefault(require("../PrimaryNav"));
var _ServicesNav = _interopRequireDefault(require("../ServicesNav"));
const MainNav = _ref => {
  let {
    menuItems,
    fetchError,
    reload,
    ModalComp,
    openChangePasswordModal
  } = _ref;
  const navSections = menuItems && menuItems.primary && menuItems.services ? [/*#__PURE__*/_react.default.createElement(_PrimaryNav.default, {
    key: "primaryNav",
    menuItems: menuItems.primary,
    ModalComp: ModalComp
  }), ...(menuItems.credits ?
  // @ts-ignore
  [/*#__PURE__*/_react.default.createElement(_CreditsUsage.default, {
    link: menuItems.credits.link,
    key: "creditsUsage"
  })] : []), /*#__PURE__*/_react.default.createElement(_ServicesNav.default, {
    key: "servicesNav",
    menuItems: menuItems.services,
    openChangePasswordModal: openChangePasswordModal
  })] : null;
  return /*#__PURE__*/_react.default.createElement(_Main.MainNavWrapper, null, /*#__PURE__*/_react.default.createElement(_WidthWrapper.default, null, fetchError && /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "header-load-error",
    "data-testid": "header-load-error"
  }, /*#__PURE__*/_react.default.createElement(_ErrorMessage.default, {
    message: "HeaderMenus.LoadError",
    onAction: reload
  })), !fetchError && /*#__PURE__*/_react.default.createElement(_Main.MainNavInner, {
    id: "nav-container"
  }, /*#__PURE__*/_react.default.createElement(_IcisLogo.IcisLogo, null), navSections)));
};
var _default = exports.default = MainNav;